module.exports = __webpack_public_path__ + "img/qrcode-box2.2b0fcfc8.png";